import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';

import RichTextConverter from '../Common/RichText/RichTextConverter';
import * as styles from './IconList.module.scss';

const Icons = ({ list, column = false }) => {
  return (
    <div className={column ? styles.gridFix : ''}>
      <ul className={styles.ul}>
        {list.map((item, i) => {
          return (
            <li
              data-analytics-component={'icon-list-item'}
              data-analytics-id={item.title}
              key={i}
              className={column ? styles.column : ''}
            >
              <img alt={item.title} loading="lazy" src={item.image?.file?.url || 'https://placekitten.com/50/50'} />
              <span>{item.title}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

const IconList = ({ heading, paragraph, list = [], gatsbyImage, id }) => {
  let hasImage = !!gatsbyImage;

  return (
    <div
      className={[styles.container, hasImage ? '' : styles.half].join(' ')}
      id={id}
      data-analytics-section={'icon-list'}
    >
      <div>
        {heading && hasImage && <h3>{heading}</h3>}
        {!hasImage && heading && <h2>{heading}</h2>}
        {paragraph?.raw && <RichTextConverter copy={paragraph} />}
        {!paragraph?.raw && <p>{paragraph}</p>}
        {hasImage && <Icons list={list} />}
      </div>
      {!hasImage && <Icons list={list} column={true} />}
      {hasImage && (
        <div className={styles.imageContainer}>
          <GatsbyImage image={gatsbyImage} alt={''} />
        </div>
      )}
    </div>
  );
};

IconList.propTypes = {
  // myProp: PropTypes.string.isRequired
};

export default IconList;
